import { render, staticRenderFns } from "./PrenotazioneWarningDialog.vue?vue&type=template&id=4c0e0c98&scoped=true&"
import script from "./PrenotazioneWarningDialog.vue?vue&type=script&lang=js&"
export * from "./PrenotazioneWarningDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioneWarningDialog.vue?vue&type=style&index=0&id=4c0e0c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e0c98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VExpansionPanel,VExpansionPanelContent,VSpacer})
